import { render, staticRenderFns } from "./FormInputReservationType.vue?vue&type=template&id=81c77bf6&scoped=true&lang=pug"
import script from "./FormInputReservationType.vue?vue&type=script&lang=ts"
export * from "./FormInputReservationType.vue?vue&type=script&lang=ts"
import style0 from "./FormInputReservationType.vue?vue&type=style&index=0&id=81c77bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c77bf6",
  null
  
)

export default component.exports